module.exports = __webpack_public_path__ + "img/lookbook_10_center.36cfd91b.png";